<template>
  <div id="app">
    <router-view />
    <div v-if="mustDownload" id="install-tip">
      <p>📱 Voeg deze app toe aan je beginscherm!</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    mustDownload: false,
  }),
  mounted() {
    const isMobile = /Android|iPhone|iPad|iPod|Windows Phone/i.test(
      navigator.userAgent
    )
    const isInStandalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone

    if (
      isMobile &&
      !isInStandalone &&
      !window.location.href.includes('localhost')
    ) {
      this.mustDownload = true
    }

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        // Page is now visible
        if ('serviceWorker' in navigator) {
          navigator.serviceWorker.getRegistration().then((reg) => {
            if (reg) {
              console.log('[TOEP] Checking for service worker update...')
              reg.update()
            }
          })
        }
      }
    })
  },
  beforeUnmount() {
    document.removeEventListener(
      'visibilitychange',
      this.handleVisibilityChange
    )
  },
}
</script>
